// extracted by mini-css-extract-plugin
export var label = "InputTypeSwitch-module--label--1GSRz";
export var asterix = "InputTypeSwitch-module--asterix--3KpRE";
export var formControl = "InputTypeSwitch-module--form-control--3PVw4";
export var mktoInvalid = "InputTypeSwitch-module--mktoInvalid--33Jfl";
export var errorMessage = "InputTypeSwitch-module--error-message--1kjb4";
export var formControlError = "InputTypeSwitch-module--form-control-error--1NgLw InputTypeSwitch-module--form-control--3PVw4";
export var formField = "InputTypeSwitch-module--form-field--1jzP2";
export var radioGroup = "InputTypeSwitch-module--radio-group--EXzAr";
export var oneCol = "InputTypeSwitch-module--one-col--38lwn";